import { Component, EventEmitter, HostListener, Input, OnChanges, OnDestroy, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { MeasurementUnit } from 'app/models/measurement-unit/measurement-unit';
import { SimpleProduct } from 'app/models/product/product/simple-product';

import { CartService } from 'app/services/cart/cart.service';

@Component({
  selector: 'custom-input-number',
  templateUrl: './custom-input-number.component.html',
  styleUrls: ['./custom-input-number.component.scss'],
})
export class CustomInputNumberComponent implements OnInit, OnChanges {

  constructor(private _cartService: CartService,
    private _toastrService: NbToastrService,
    private _router: Router) { }

  @Input() loading: boolean = false;
  @Output() loadingEmitter: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input() product: SimpleProduct;
  @Input() styleConfig: any;
  @Input() measurementUnit: MeasurementUnit;
  @Input() fromCart: boolean = false;

  @Output() productChange = new EventEmitter();

  rollbackQuantity: number = 0;
  buyButtonText: string = 'ADICIONAR';
  isAvailable: boolean = false;
  focus: boolean = false;

  ngOnInit(): void {
    this.isAvailable = (this.product.quantity > 0 || this.product.quantity == null);
    this.buyButtonText = this.isAvailable ? 'ADICIONAR' : 'INDISPONÍVEL';
  }

  ngOnChanges(): void {
    this.rollbackQuantity = this.replaceString(this.measurementUnit.cartQuantity);
  }

  alreadyAdded() {
    return (this.measurementUnit && this.measurementUnit.cartQuantity > 0);
  }

  setFocus() {
    this.focus = true;
  }

  addProduct() {
    if (this.isAvailable) {
      if (!this.measurementUnit) {
        let defaultUnit: MeasurementUnit = this.product?.measurementUnits?.find(
          (e) => e.defaultUnit
        );

        if (!defaultUnit) {
          this._toastrService.danger('Não foi possível identificar a unidade de medida padrão');
          return;
        }
      }
      this.rollbackQuantity = this.measurementUnit.cartQuantity;
      this.measurementUnit.cartQuantity = 1;
      this.sendRequest('+', 1);
    }
  }

  minus() {
    this.rollbackQuantity = this.measurementUnit.cartQuantity;
    this.measurementUnit.cartQuantity--;
    this.sendRequest('-', this.measurementUnit.cartQuantity);
  }

  plus() {
    this.rollbackQuantity = this.measurementUnit.cartQuantity;
    this.measurementUnit.cartQuantity++;
    this.sendRequest('+', this.measurementUnit.cartQuantity);
  }

  validateKey(value: string) {
    if (this.alreadyAdded()) {
      const quantity = this.replaceString(value);
      if (quantity != null && quantity != undefined && quantity != this.rollbackQuantity) {
        this.measurementUnit.cartQuantity = quantity;
        this.rollbackQuantity = this.measurementUnit.cartQuantity;
        this.sendRequest('=', this.measurementUnit.cartQuantity);
      }
    } else if (this.replaceString(value) == 0) {
      this.measurementUnit.cartQuantity = this.replaceString(value);
      this.rollbackQuantity = this.measurementUnit.cartQuantity;
      this.sendRequest('=', this.measurementUnit.cartQuantity);
    }

    this.focus = false;
  }

  sendRequest(operation: string, quantity?: number) {
    this.loading = true;
    this.loadingEmitter.emit(this.loading);

    this._cartService.updateProduct(this.product, this.measurementUnit, operation, quantity, this.fromCart).subscribe((value) => {
      this.measurementUnit.cartQuantity = value.data.data.quantity;
      this._cartService.cartSize = value.data.data.cartQuantity;
      this.product.selectedQuantity = value.data.data.quantity;
    }, error => {
      this.measurementUnit.cartQuantity = this.rollbackQuantity;
      this._toastrService.danger('Erro ao atualizar os dados do carrinho! Detalhes: ' + error.error.message, 'Atenção');
    }).add(() => {
      this.loading = false;
      this.loadingEmitter.emit(this.loading);
      this.productChange.emit(this.product);
    });
  }

  replaceString(object) {
    let stringObject = object.toString();
    while (stringObject.includes('-') || stringObject.includes('.') || stringObject.includes(',')
      || stringObject.includes('´') || stringObject.includes('~') || stringObject.includes('[')
      || stringObject.includes(']') || stringObject.includes(';')) {
      stringObject = stringObject.replace('-', '').replace('.', '').replace(',', '')
        .replace('´', '').replace('~', '').replace('[', '').replace(']', '').replace(';', '');
    }
    const result: number = +stringObject;
    return result;
  }

  goToDetails() {
    sessionStorage.setItem('transitionalProduct', JSON.stringify(this.product));
    this._router.navigate([`pages/products/detail`], { queryParams: { productId: this.product.id, clasId: this.product.classificationId } });
  }
}
